import React__default from 'react';
import { Alert } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { PD_ALERT_TITLE_LABEL, PD_ALERT_MESSAGE_LABEL } from '../../types.js';

const PrescriptionFormPupillaryDistanceAlert = ({ className  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React__default.createElement(Alert, {
        type: "info",
        icon: "information-circle",
        title: getLabel(PD_ALERT_TITLE_LABEL),
        message: getLabel(PD_ALERT_MESSAGE_LABEL),
        className: className
    });
};

export { PrescriptionFormPupillaryDistanceAlert };
//# sourceMappingURL=PrescriptionFormPupillaryDistanceAlert.js.map
